import generateSrc from '@/core/responsive/image/helpers/generate-src';
import { IImageOptions } from '@/core/responsive/image/image.types';

function generateSrcset(src: string, options: IImageOptions, sizes: number[]): string {
    const srcset: string[] = [];

    sizes.forEach((width: number) => {
        let url = generateSrc(src, { ...options, width: width });

        url = `${url} ${width}w`;
        srcset.push(url);
    });

    return srcset.join(',');
}

export default generateSrcset;
